<script setup lang="ts">
import PlatformAuthForm from '~/components/platform/PlatformAuthForm.vue'

definePageMeta({layout: 'platform'})
const {t} = useI18n()
useSeoMeta({
  title: function loginTitle() {
    return t('platform.auth.signInTitle')
  },
})
</script>

<template>
  <div class="mx-auto max-w-md px-4 py-12 flex flex-col gap-6">
    <h1 class="text-2xl font-bold text-highlighted">{{ t('platform.auth.signInTitle') }}</h1>
    <PlatformAuthForm mode="signIn"/>
    <NuxtLinkLocale to="/signup" class="text-sm text-primary">{{ t('platform.auth.switchToSignUp') }}</NuxtLinkLocale>
  </div>
</template>
